module.exports = __webpack_public_path__ + "Flag-796.2ac67fbc97c9a12fdf1591183fbc1b7d.svg";